import {
  buildAdjustPositionEndCommand,
  buildAdjustPositionStartCommand,
  buildFeedPaperCommand,
  buildPositionToNextLabelCommand,
  buildSetTattooPaperTypeCommand,
} from "./protocol";

/** Paper / feed behaviour after printing. */
export type LuckPaperMode = "continuous" | "label-gap" | "tattoo";

/** @deprecated Use LuckPaperMode */
export type LuckPrintMode = LuckPaperMode;

export type PaperModeOption = {
  value: LuckPaperMode;
  label: string;
  hint: string;
};

export const PAPER_MODE_OPTIONS: PaperModeOption[] = [
  {
    value: "label-gap",
    label: "ສຕິກເກີ (gap)",
    hint: "ຈັດຕຳແໜ່ງ gap ອັດຕະໂນມັດ — ແນະນຳສຳລັບປ້າຍຂົນສົ່ງ",
  },
  {
    value: "continuous",
    label: "ມ້ວນເຈ້ຍ",
    hint: "Feed ດ້ວຍ dots — ສຳລັບມ້ວນເຈ້ຍຕໍ່ເນື່ອງ",
  },
  {
    value: "tattoo",
    label: "Tattoo",
    hint: "ເຈ້ຍ tattoo — ປັບ feed dots ຕາມຄວາມຍາວ",
  },
];

/** @deprecated Use PAPER_MODE_OPTIONS */
export const PRINT_MODE_OPTIONS = PAPER_MODE_OPTIONS;

export function paperModeUsesFeedDots(mode: LuckPaperMode): boolean {
  return mode === "continuous" || mode === "tattoo";
}

/** @deprecated Use paperModeUsesFeedDots */
export const printModeUsesFeedDots = paperModeUsesFeedDots;

export function buildPreRasterCommands(mode: LuckPaperMode): Uint8Array[] {
  switch (mode) {
    case "label-gap":
      return [buildAdjustPositionStartCommand()];
    case "tattoo":
      return [buildSetTattooPaperTypeCommand()];
    default:
      return [];
  }
}

export function buildPostRasterCommands(
  mode: LuckPaperMode,
  feedDots: number,
): Uint8Array[] {
  switch (mode) {
    case "label-gap":
      return [
        buildPositionToNextLabelCommand(),
        buildAdjustPositionEndCommand(),
      ];
    case "continuous":
    case "tattoo":
      return [buildFeedPaperCommand(feedDots)];
  }
}
